import React from "react";
import { Dashline } from "../../assets";
import { locales } from "../../locales";
import { formatNumber } from "../../utils/communesUtils";

const Housing = ({ data, langId }) => {
  const { areaPurchased, priceAverage, priceSquareMeter } = data.propertyPrices;
  const { vacantHouses } = data;
  const linePosition = (priceAverage / priceSquareMeter) * 100;
  const priceLabel = langId === "fr" ? "euros/m²" : "Euro/m²";
  const maxPriceSquareMeter = 10000; // Define the maximum value for priceSquareMeter
  const percentageWidth = (priceSquareMeter / maxPriceSquareMeter) * 100;
  //const isCheap = priceSquareMeter < priceAverage;

  return (
    <div className="flex flex-col mt-20">
      <span className="text-left font-bold mt-5 mb-3 text-22 leading-26 uppercase wort-medium:px-5">
        {locales[langId].housing}
      </span>
      <hr />
      <span className="text-22 leading-26 text-left font-bold mt-8 wort-medium:px-5">
        {locales[langId].housingPrice}
      </span>
      <div className="flex flex-col mt-6 justify-between wort-medium:flex-row wort-medium:px-5">
        <div className="flex flex-row h-[240px] w-1/2 pr-4">
          <div className="flex h-56 w-[120px] items-center mr-4 pb-10">
            <span className="text-right uppercase text-sm font-bold leading-[16.8px]">
              {locales[langId].housingPriceAverage}
            </span>
          </div>
          <div className="flex flex-col h-96 min-w-[236px]">
            <div className="h-44 flex items-center border-4 border-l-sky-900 border-r-0 border-t-0 border-b-0 relative">
              <div
                className="bg-[#86CDEB] h-16flex items-center pl-6"
                style={{ width: `${percentageWidth}%` }}
              >
                <span className="text-2xl text-center font-bold">
                  {`${formatNumber(priceSquareMeter)} ${priceLabel}`}
                </span>
              </div>
              <div
                className="absolute left-0 top-0 bottom-0"
                style={{
                  marginLeft: `${linePosition}%`,
                }}
              >
                <Dashline style={{ height: 176 }} />
                <div
                  className="flex flex-col items-center"
                  style={{
                    marginLeft: `${-linePosition - 30}%`,
                    marginTop: -16,
                  }}
                >
                  <span className="text-22 font-bold leading-[26.4px]">
                    {formatNumber(priceAverage) + " " + priceLabel}
                  </span>
                  <span className="text-xs leading-[14.4px] mt-1">
                    {locales[langId].housingNationalPriceAverage}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 bg-wort-background pb-4 wort-medium:h-[170px] wort-medium:w-1/2 wort-medium:items-center">
          <div className="w-full h-90 flex items-center flex-col mt-5 border-r-2">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-32 wort-medium:leading-38">
              {areaPurchased + " m²"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:w-[223px] wort-medium:mt-2">
              {locales[langId].housingAreaPurchased}
            </span>
          </div>
          <div className="w-full h-90 flex items-center flex-col mt-5">
            <span className="text-36 leading-[45px] font-bold text-secondary wort-medium:text-32 wort-medium:leading-38">
              {vacantHouses.toString().replace(".", ",") + " %"}
            </span>
            <span className="text-xs leading-ls text-center wort-medium:text-base wort-medium:leading-5 wort-medium:w-[223px] wort-medium:mt-2">
              {locales[langId].housingVacantHousesPercentage}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Housing;
